$arch_app $mol_page
	title \Фрактальный Архиватор
	body /
		<= Initial_section $mol_row sub /
			<= Initial_length_labeler $mol_labeler
				title \Длина строки
				content / <= Initial_length $mol_paragraph title <= initial_length \0
			<= Initial_labeler $mol_labeler
				title \Исходная строка
				content / <= Initial $mol_string value? <=> initial? \0123456789абвгде
		<= Result $mol_row sub /
			<= Result_count_labeler $mol_labeler
				title \Кол-во итераций
				content / <= Result_count $mol_paragraph title <= result_count \0
			<= Result_all_length_labeler $mol_labeler
				title \Всего символов
				content / <= Result_all_length $mol_paragraph title <= result_all_length \0
			<= Result_meta_length_labeler $mol_labeler
				title \Длина метаданных
				content / <= Result_meta_length $mol_paragraph title <= result_meta_length \0
			<= Result_meta_labeler $mol_labeler
				title \Метаданные
				content / <= Result_meta $mol_paragraph title <= result_meta \
			<= Result_labeler $mol_labeler
				title \Длина результата
				content / <= Result_length $mol_paragraph title <= result_length \0
			<= Result_value_labeler $mol_labeler
				title \Результат
				content / <= Result_value $mol_paragraph title <= result_value \0
		<= Fractal_list $mol_list rows <= fractal_list /
			<= Fractal*0 $mol_view sub /
				<= Fractal_remove* $mol_button_major
					title \X
					click? <=> fractal_remove*? null
				<= Fractal_name_labeler* $mol_labeler
					title \Имя
					content / <= Fractal_name* $mol_paragraph title <= fractal_name* \
				<= Fractal_length_labeler* $mol_labeler
					title \Длина
					content / <= Fractal_length* $mol_paragraph title <= fractal_length* \
				<= Fractal_result_labeler* $mol_labeler
					title \Результат
					content / <= Fractal_result* $mol_paragraph title <= fractal_result* \
				<= Fractal_decode_labeler* $mol_labeler
					title \Декодирование
					content / <= Fractal_decode* $mol_paragraph title <= fractal_decode* \
	foot /
		<= Add_alogoritm $mol_row sub /
			<= Algorithm_switch $mol_switch
				value? <=> algorithm? \lzw64
				options <= algorithms *
					lzw64 \lzw64
					sub4 \Уменьшить на 4
					sub8 \Уменьшить на 8
					sub16 \Уменьшить на 16
					add3 \Добавить 3
			<= Add_fractal $mol_button_major
				title \Добавить шаг
				click? <=> fractal_add? null
		
